const getState = (state: AppState) => state.admin;

export const adminSelector = {
  getState,
};
